import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { either, prop } from 'ramda'
import { useMakeDispatchCallback } from 'hooks'
import { setSelectedIdWithDrawer } from 'actions/navigator'
import { useSelector } from 'hooks/redux'
import { getOutputtingDataToList } from 'selectors/feature/logicNodes'

import strings from 'utils/strings'

import { InputLabel } from 'components/patterns'
import withStyle, { StyledButton } from './OutputtingDataTo.style'

/* eslint-disable react-hooks/exhaustive-deps */
const OutputtingDataTo = ({ uri, className }) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)
  const outputList = useSelector(getOutputtingDataToList, { uri })

  const renderOutputList = useMemo(
    () => outputList.map(renderLink(setSelectedIdCallback)),
    [outputList]
  )

  return (
    <div className={className}>
      <InputLabel label={strings.outputting_to_label} vertical weight="bold" />
      {renderOutputList}
    </div>
  )
}

OutputtingDataTo.propTypes = {
  uri: PropTypes.string.isRequired,
  className: PropTypes.node,
}

export default withStyle(OutputtingDataTo)

const renderLink = (setSelectedIdCallback) => (output) => {
  const { description } = output
  const getId = either(prop('uri'), prop('id'))
  const id = getId(output)

  return (
    <StyledButton
      key={description}
      dataTestId="outputting-data-to-button"
      link
      onClick={() => setSelectedIdCallback(id)}
    >
      {description}
    </StyledButton>
  )
}
